import React from 'react'
import styled from 'styled-components'

import { Input as GenericInput } from '../../components/Input'

const StyledWrapper = styled.div`
  display: table;
  border-collapse: separate;
  width: 100%;
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  border-color: ${(props) => {
    if (props.isFocused) {
      return '#80deea'
    } else if (props.showError) {
      return '#f52e2e'
    }
    return '#9999bd'
  }};
  overflow: hidden;
`

const Wrapper = ({ children, className, errors, touched, isFocused }) => {
  const showError = errors && touched

  return (
    <StyledWrapper showError={showError} className={className} isFocused={isFocused}>
      {children}
    </StyledWrapper>
  )
}

const StyledAddon = styled.div`
  padding: 12px 10px;
  font-size: 13px;
  color: #5d5c70;
  background-color: #f2f2f2;
  text-align: center;
  width: 1%;
  display: table-cell;
  vertical-align: middle;
  white-space: nowrap;
`

const Addon = ({ children, className }) => {
  return <StyledAddon className={className}>{children}</StyledAddon>
}

const StyledInput = styled(GenericInput)`
  display: table-cell;
  border: none;
`

const Input = (props) => {
  return <StyledInput {...props} />
}

export default {
  Wrapper,
  Addon,
  Input
}
